// ** Reactstrap Imports
import { Button } from 'reactstrap'

const BuyNow = () => {
  return (
    <div className='buy-now'>
      <Button tag='a' color='danger' href='https://1.envato.market/vuexy_admin' target='_blank'>
        Buy Now
      </Button>
    </div>
  )
}

export default BuyNow
